
/**
 * Generates a Subresource Integrity (SRI) hash for a given script content
 * @param content The script content to hash
 * @returns The SRI hash in the format "sha384-HASH"
 */
export async function generateIntegrityHash(content: string): Promise<string> {
  try {
    // Convert the script content to a Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(content);
    
    // Generate the SHA-384 hash using the Web Crypto API
    const hashBuffer = await crypto.subtle.digest('SHA-384', data);
    
    // Convert the hash to base64
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashBase64 = btoa(String.fromCharCode(...hashArray));
    
    // Return the hash in the SRI format
    return `sha384-${hashBase64}`;
  } catch (error) {
    console.error('Failed to generate integrity hash:', error);
    return '';
  }
}
